import { Link } from "gatsby";
import React, { FC } from "react";
import styled from "styled-components";

const Ol = styled.ol`
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 8px 0;
  align-items: center;
`;
const Li = styled.li`
  &::after {
    margin: auto 8px;
    content: ">";
    color: gray;
  }
`;

interface BreadCrumbItem {
  name: string;
  url: string;
}

interface Props {
  items: BreadCrumbItem[];
}

const BreadCrumb: FC<Props> = ({ items }) => {
  return (
    <Ol itemScope itemType="https://schema.org/BreadcrumbList">
      <>
        <meta itemProp="name" content="パンくずリスト" />
        {items.map(({ url, name }, index) => {
          return (
            <Li
              key={url}
              itemProp="itemListElement"
              itemScope
              itemType="https://schema.org/ListItem"
            >
              <Link itemProp="item" to={url}>
                <span itemProp="name">{name}</span>
                <meta itemProp="position" content={`${index + 1}`} />
              </Link>
            </Li>
          );
        })}
      </>
    </Ol>
  );
};

export default BreadCrumb;
